import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';

@Component({
    selector: 'app-edit-media',
    templateUrl: './edit-media.component.html',
    styleUrls: ['./edit-media.component.scss']
})
export class EditMediaComponent implements OnInit {
    public form: FormGroup;
    uploadImageSrc: string;

    public channels: any[] = [
        {
            value: 'CH 1255',
            label: 'CH 1255'
        },
        {
            value: 'CH 6722',
            label: 'CH 6722'
        },
        {
            value: 'CH 2991',
            label: 'CH 2991'
        }
    ];

    public rules: any[] = [
        {
            value: 'Generic',
            label: 'Generic'
        },
        {
            value: 'Sunny Day',
            label: 'Sunny Day'
        },
        {
            value: 'Rain',
            label: 'Rain'
        }
    ];

    public constructor(private formBuilder: FormBuilder) {}

    ngOnInit(): void {
        this.initForm();
    }

    private initForm(): void {
        this.form = this.formBuilder.group({
            media_title: new FormControl(null),
            all_channels: new FormControl(null),
            channel: new FormControl(null),
            rule: new FormControl(null),
            upload_img: new FormControl(null)
        });
    }

    onImgFileChange(event): void {
        const reader = new FileReader();

        if (event.target.files && event.target.files.length) {
            const [file] = event.target.files;
            reader.readAsDataURL(file);

            reader.onload = () => {
                this.uploadImageSrc = reader.result as string;

                this.form.patchValue({
                    fileSource: reader.result
                });
            };
        }
    }
}
